import type { DomApplier } from '../cssFeatures.types'

export const fontFacesDomApplier: DomApplier<'fontFaces'> = () => null
